import { render, staticRenderFns } from "./basmsg.vue?vue&type=template&id=0c5634c9&scoped=true&"
import script from "./basmsg.vue?vue&type=script&lang=js&"
export * from "./basmsg.vue?vue&type=script&lang=js&"
import style0 from "./basmsg.vue?vue&type=style&index=0&id=0c5634c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5634c9",
  null
  
)

export default component.exports